// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__59wJP","inner":"Footer_inner__2jUai","nextIcon":"Footer_nextIcon__2tIIo","innerLeft":"Footer_innerLeft__3elmO"};